
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../state';
import { checkPasswordChangeTokenValidity, postTokenPasswordChange } from '../../client/password';
import { $router } from '../../../main';
import PasswordField from '../../fields/PasswordField.vue';
import { appLogin } from '../../../app_hooks';

@Component({
    components: { PasswordField, ValidationObserver },
})
export default class TokenPasswordChange extends Vue {
    @Prop(String) readonly token!: string;

    shared = sharedState;
    local = {
        password: '',
        password2: '',
        tokenIsValid: false,
        tokenValidityResult: '',
    };

    async mounted() {
        this.local.tokenValidityResult = (await checkPasswordChangeTokenValidity(this.token)).message;
        if (this.local.tokenValidityResult === 'ok') {
            this.local.tokenIsValid = true;
        }
    }

    async changePassword() {
        if (await postTokenPasswordChange(this.local.password!!, this.token)) {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChanged').toString(),
                type: 'is-success',
                position: 'is-top',
            });
            this.local.password = '';
            this.local.password2 = '';
            await appLogin();
            await $router.push('/');
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordChangedFailed').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }

    async submit() {
        if (this.local.password == this.local.password2) {
            await this.changePassword();
        } else {
            this.$buefy.toast.open({
                message: this.$t('message.passwordsDoNotMatch').toString(),
                type: 'is-warning',
                position: 'is-top',
            });
        }
    }

    forgotPassword() {
        this.$router.push('/login/request-password-change');
    }
}
